import { useRef, useEffect } from "react";
import Hls from "hls.js";
import { API, dlToken } from "@/lib/api";

const isHls = (u) => /\.m3u8(\?|$)/i.test(u || "");
const isVideoFile = (u) => /\.(mp4|webm)(\?|$)/i.test(u || "");
const isRtsp = (u) => /^rtsp:\/\//i.test(u || "");

// Odtwarzacz kamery: RTSP (przez bramkę HLS serwera) / bezpośredni HLS / MP4-WEBM / MJPEG-snapshot.
export default function CameraView({ item, className, style, testid }) {
  const videoRef = useRef(null);
  const cam = (item?.camera_url || "").trim();
  const rtsp = (item?.rtsp_url || "").trim() || (isRtsp(cam) ? cam : "");
  const hlsSrc = (item?.id && rtsp) ? `${API}/stream/${item.id}/index.m3u8` : (isHls(cam) ? cam : "");

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !hlsSrc) return undefined;
    let hls;
    if (Hls.isSupported()) {
      hls = new Hls({ xhrSetup: (xhr) => { xhr.withCredentials = true; } }); // sesja z ciasteczka
      hls.loadSource(hlsSrc);
      hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = `${hlsSrc}?auth=${encodeURIComponent(dlToken())}`; // Safari native
    }
    return () => { if (hls) hls.destroy(); };
  }, [hlsSrc]);

  if (hlsSrc) return <video ref={videoRef} controls autoPlay muted playsInline className={className} style={style} data-testid={testid} />;
  if (isVideoFile(cam)) return <video src={cam} controls autoPlay muted playsInline className={className} style={style} data-testid={testid} />;
  if (cam) return <img src={cam} alt="Kamera IP" className={className} style={style} data-testid={testid} />;
  return <div className={className} style={{ ...style, display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b", fontSize: 12 }}>—</div>;
}
